<template>
  <div :class="`p-4 theme-list ${viewType}`">
    <!--    <CRow class="mb-3">-->
    <!--      <CCol class="view-as">-->
    <!--        View as <a @click="setView('list')" href="#">List</a> | <a @click="setView('grid')" href="#">Grid</a>-->
    <!--      </CCol>-->
    <!--    </CRow>-->

    <template v-if="viewType === 'list'">
      <c-row v-for="(theme, index) in themes" :key="index" class="py-2 theme-row">
        <c-col class="theme-image" sm="1">
          <img v-lazy="getThemeThumbUrl(theme.key)" class="screenshot" />
        </c-col>
        <c-col class="theme-name" sm="6">
          <router-link
            :to="{ name: 'themeDetails', params: { themeKey: theme.key } }"
            v-html="theme.name"
          ></router-link>
        </c-col>
        <c-col class="theme-notes" sm="1"></c-col>
        <c-col class="theme-themes" sm="4">
          <span class="mt-2 d-block float-right">
            <pill :value="theme.installCount" />
          </span>
        </c-col>
      </c-row>
    </template>

    <template v-else>
      <c-row class="py-2 theme-row">
        <c-col v-for="(theme, index) in themes" :key="index" class="theme-image mb-3" sm="6" md="4" lg="3" xl="2">
<!--        <c-col v-for="(theme, index) in themes" :key="index" class="theme-image mb-3" sm="6" md="3" lg="2" xl="1">-->
          <c-card>
            <router-link :to="{ name: 'themeDetails', params: { themeKey: theme.key } }">
              <c-card-img :src="getThemeThumbUrl(theme.key)"/>
            </router-link>
            <c-card-body>
              <c-card-title style="font-size: 1rem">
                <router-link
                    :to="{ name: 'themeDetails', params: { themeKey: theme.key } }"
                    v-html="theme.name"
                    class="text-truncate"
                    style="display: inline-block; max-width: 100%"
                />
              </c-card-title>
              <!--              <c-card-subtitle class="text-truncate" style="display: inline-block; max-width: 100%"></c-card-subtitle>-->
            </c-card-body>
            <c-card-footer>
              <span>Installations <strong>{{ theme.installCount }}</strong></span>
            </c-card-footer>
          </c-card>
<!--          <div class="theme-name-wrapper d-flex align-bottom align-bottom">-->
<!--            <router-link-->
<!--              class="theme-name"-->
<!--              :to="{ name: 'themeDetails', params: { themeKey: theme.key } }"-->
<!--              v-html="theme.name + ` (${theme.installCount})`"-->
<!--            />-->
<!--          </div>-->
<!--          <router-link :to="{ name: 'themeDetails', params: { themeKey: theme.key } }" style="position:relative;">-->
<!--            <img v-lazy="getThemeThumbUrl(theme.key)" class="screenshot" />-->
<!--          </router-link>-->
        </c-col>
      </c-row>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import { freeSet } from '@coreui/icons';
import VueLazyload from 'vue-lazyload';
import ConfirmModal from '@/views/components/ConfirmModal';
import Pill from './Pill';
import { getThemeThumbUrl } from '@/libs/theme/getThemeThumbUrl';

const placeholderImage = process.env.VUE_APP_THEME_PLACEHOLDER_IMAGE_URL;
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: placeholderImage,
  loading: placeholderImage,
  attempt: 1,
});

export default {
  name: 'ThemeList',
  components: {
    ConfirmModal,
    Pill,
  },
  props: {
    themes: Array,
    viewTypeDefault: String,
  },
  data() {
    return {
      error: null,
      freeSet,
      viewType: 'list',
    };
  },
  created() {
    this.viewType = this.viewTypeDefault || 'list';
  },
  mounted() {},
  methods: {
    setView(type) {
      this.viewType = type;
    },
    getThemeThumbUrl,
  },
};
</script>

<style lang="scss" scoped="">
.view-as {
  font-size: 14px;
  a {
    font-weight: bold;
    font-size: inherit;
  }
}

.c-dark-theme {
  .theme-list {
    background-color: #23242d;
    &.list {
      .theme-row {
        border-bottom: 1px solid #333;
      }
    }
    &.grid {
      .theme-name {
        color: white;
      }
    }
  }
}

.theme-list {
  @media (max-width: 576px) {
    .col-sm-6 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
  @media (min-width: 1200px) {
    .col-xl-2 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: 25%;
    }
  }
  @media (min-width: 1600px) {
    .col-xl-2 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 16.66667%;
      flex: 0 0 16.66667%;
      max-width: 16.66667%;
    }
  }
  @media (min-width: 2200px) {
    .col-xl-2 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 12%;
      flex: 0 0 12%;
      max-width: 12%;
    }
  }
  //@media (min-width: 1200px) {
  //  .col-xl-1 {
  //    -webkit-box-flex: 0;
  //    -ms-flex: 0 0 16.66667%;
  //    flex: 0 0 16.66667%;
  //    max-width: 16.66667%;
  //  }
  //}
  //@media (min-width: 1600px) {
  //  .col-xl-1 {
  //    -webkit-box-flex: 0;
  //    -ms-flex: 0 0 10%;
  //    flex: 0 0 10%;
  //    max-width: 10%;
  //  }
  //}
  //@media (min-width: 2200px) {
  //  .col-xl-1 {
  //    -webkit-box-flex: 0;
  //    -ms-flex: 0 0 8%;
  //    flex: 0 0 8%;
  //    max-width: 8%;
  //  }
  //}

  font-size: 12px;
  &.list {
    .theme-row {
      border-bottom: 1px solid #eee;
    }
    .theme-name {
      font-weight: bold;
      .theme-link {
        font-weight: normal;
      }
    }
    .theme-notes {
      & > span {
        cursor: pointer;
      }
    }
    .screenshot {
      width: 50px;
      &.no-image {
        opacity: 0.5;
      }
    }
  }
  &.grid {
    .card-img {
      padding: 20%;
    }
    .update-count {
      position: absolute;
      right: 30px;
      top: 0;
    }
    .screenshot {
      width: 90%;
      &:hover {
        outline: 1px solid #00d1b2;
      }
      &.no-image {
        opacity: 0.5;
      }
    }
    .theme-name-wrapper {
      margin-bottom: 10px;
      min-height: 50px;
      height: 50px;
      position: relative;
    }
    .theme-name {
      font-weight: bold;
      font-size: 12px;
      position: absolute;
      bottom: 0;
    }
  }
}
</style>
